<div class="gc-dg-inner-card-container">
    <p class="gc-dg-font-semibold gc-dg-font-lg">
        Monthly Protection for your {{applianceBrand}} {{applianceDescription}}
    </p>
    <div data-gc-dg-element="gc-dg-item-subtotal">
        <p class="gc-dg-d-inline">subtotal</p>
        <p data-gc-dg-element="gc-dg-base-item-net-amount"
            class="gc-dg-d-inline gc-dg-float-right gc-dg-font-semibold gc-dg-base-price">
            ${{netAmount}}*
        </p>
        <p class="gc-dg-d-inline gc-dg-float-right gc-dg-font-semibold gc-dg-ach-price">
            ${{achNetAmount}}*
        </p>
    </div>
    <p data-gc-dg-element="gc-dg-ach-item-discount-banner"
        class="gc-dg-d-inline gc-dg-green-color gc-dg-font-semibold gc-dg-ach-price gc-dg-show-discount">
        ACH discount ({{achDiscountedPercentage}}% off for 6 months)
    </p>

    <div data-gc-dg-element="gc-dg-summary-tax">
        <p class="gc-dg-d-inline">Est. sales tax</p>
        <p class="gc-dg-d-inline gc-dg-float-right gc-dg-font-semibold gc-dg-base-price">
            ${{salesTaxAmount}}
        </p>
        <p class="gc-dg-d-inline gc-dg-float-right gc-dg-font-semibold gc-dg-ach-price">
            ${{achSalesTaxAmount}}
        </p>
    </div>
    <hr />
    <p>Payment start date: {{startDate}}</p>
</div>